'use strict';

class Presskit {
	constructor(props = {}) {
		console.log('Presskit::constructor(%o)', props);
		Object.assign(this, props);

		this.apps = document.getElementById('apps');

		this.videos = document.getElementById('videos');
		this.videoUrl = this.videos?.querySelectorAll('.video_url');

		this.allTabs = document.querySelector('.predefined_amounts');

		this.pageEvents();
	}

	prepareGlide(platform) {
		console.log('Presskit::prepareGlide()');
		const glide_carousel = new Glide(platform, {
			type: 'carousel',
			startAt: 0,
			perView: 1,
			classes: {
				cloneSlide: 'glide-slide--clone',
				activeNav: 'glide-bullet--active',
				activeSlide: 'glide-slide--active',
				disabledArrow: 'glide-arrow--disabled'
			}
		});
		glide_carousel.mount();

		return glide_carousel;
	}

	updateTab(selectedTab) {
		console.log('Presskit::updateTab()');
		const that = this;
		const activeSelectedTab = that.allTabs.querySelector('.active');
		activeSelectedTab?.classList.remove('active');
		selectedTab.classList.add('active');
	}

	pageEvents() {
		const that = this;
		if ($('a[data-toggle="tab"]')) {
			$('a[data-toggle="tab"]').on('shown.bs.tab', e =>  {
				const visibleTab = e.target.getAttribute('href');
				const existing_glider = !!that.apps.querySelector('.glide--carousel');
				switch (visibleTab) {
					case '#apps':
						if (that.apps && !existing_glider) {
							that.prepareGlide('.hero-ios');
							that.prepareGlide('.hero-android');
						}
						break;
					case '#videos':
						if (that.videoUrl) {
							that.videoUrl.forEach(e =>  {
								if (e.dataset.real_src !== '') {
									e.src = e.dataset.real_src;
									e.dataset.real_src = '';
								}
							});
						}
						break;
				}
			});
		}

		if (that.allTabs) {
			that.allTabs.addEventListener('click', e => {
				const clickedTab = e.target.closest('.pa_label');
				if (clickedTab && !clickedTab.classList.contains('active')) {
					that.updateTab(clickedTab);
				}
			});
		}

		if (that.videos) {
			that.videos.addEventListener('click', e => {
				const clickVideo = e.target.closest('.video_btn');
				if (clickVideo) {
					navigator.clipboard.writeText(clickVideo.dataset.embed);
				}
			});
		}
	}
}

window.addEventListener('DOMContentLoaded', () => {
	try {
		new Presskit({});
	} catch (e) {
		console.error(e);
	}
});
